
import React, { useState, useEffect, useCallback } from 'react';
import Navbar from './Navbar';
import * as XLSX from 'xlsx';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement  } from 'chart.js';


const BranchAnalytics = () => {


    const [branches, setBranches] = useState([]);
    const [students, setStudents] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState('');
    const [selectedBatch, setSelectedBatch] = useState('');
    const [selectedModeOfPayment, setSelectedModeOfPayment] = useState('');
    const [receipts, setReceipts] = useState([]); 
    const [analyticsReceipts, setAnalyticsReceipts] = useState([]); 
    const [highestFeeMonth, setHighestFeeMonth] = useState('');
    const [leastFeeMonth, setLeastFeeMonth] = useState('');
    const [averageFeePaid, setAverageFeePaid] = useState('');
    const [mostFeePaidDate, setMostFeePaidDate] = useState('');
    const [averageDailyFee, setAverageDailyFee] = useState('');
    const [totalFeeInRange, setTotalFeeInRange] = useState('');
    const [concessions, setConcessions] = useState([]);
    const user = JSON.parse(localStorage.getItem('user'));

    const currentDate = new Date().toISOString().split('T')[0];

    const [startDate, setStartDate] = useState('2023-01-01'); // Default start date
    const [endDate, setEndDate] = useState(currentDate); 

    
    const isoFormattedStartDate = `${startDate}T00:00:00.000Z`;
    const isoFormattedEndDate = `${endDate}T00:00:00.000Z`;

    const convertDateFormat = (dateString) => {
      const parts = dateString.split('-'); // Split the date by hyphen
      return `${parts[2]}-${parts[1]}-${parts[0]}`; // Rearrange the parts
    };
  
    const startDateDDMMYYYY = convertDateFormat(startDate);
    const endDateDDMMYYYY = convertDateFormat(endDate);

    const handleBranchChange = (event) => {
      const selectedOptions = Array.from(event.target.selectedOptions, option => option.value);
      setSelectedBranch(selectedOptions);
    };
    



    const fetchAnalyticsReceipts = async () => {
        try {
          const SchoolManagementSystemApi = require('school_management_system_api');
          const api = new SchoolManagementSystemApi.DbApi();
          
          let query = {
            dateIso: {
              $gte: isoFormattedStartDate,
              $lte: isoFormattedEndDate
            },
          };
      
          // Only add branch to query if selectedBranch is not null and has length
          if (selectedBranch && selectedBranch.length) {
            query.branch = { $in: selectedBranch }; // Use $in for arrays
          }
      
          // Only add batch to query if selectedBatch is not null and has length
          if (selectedBatch && selectedBatch.length) {
            query.batch = { $in: selectedBatch }; // Use $in for arrays
          }

          if (selectedModeOfPayment && selectedModeOfPayment.length) {
            query.modeOfPayment = { $in: selectedModeOfPayment }; // Use $in for arrays
          }          

          console.log(query);
          const opts = {
            body: {
              collectionName: 'receipts',
              query: query,
              type: 'findMany',
            },
          };
      
          console.log(opts.body);
      
          api.dbGet(opts, function(error, data, response) {
            if (error) {
              console.error('API Error:', error);
            } else {
              try {
                const responseBody = response.body; // Assuming response.body is already in JSON format
                console.log(responseBody);
                setAnalyticsReceipts  (responseBody); // Assuming the actual data is in responseBody.data
              } catch (parseError) {
                console.error('Error parsing response:', parseError);
              }
            }
          });
          
          
          
          
        } catch (error) {
          console.error('Error during fetch:', error);
        }
        
      };

      const handleButtonClick = () => {
        fetchAnalyticsReceipts();
      };


    const aggregateFeesByBranch = (receipts) => {
        const branchAggregates = {}; 
        var totalFeePaid =0;
        var totalFeePending =0; 
        receipts.forEach((receipt) => {
          const { branch, 
                  firstYearHostelFeePaid, firstYearTuitionFeePaid, secondYearHostelFeePaid, secondYearTuitionFeePaid,
                  firstYearTotalHostelFeePending, firstYearTotalTuitionFeePending, secondYearTotalHostelFeePending, secondYearTotalTuitionFeePending
                } = receipt;
        
            // Calculate the total fee paid and pending for the current receipt
            totalFeePaid = firstYearHostelFeePaid + firstYearTuitionFeePaid + secondYearHostelFeePaid + secondYearTuitionFeePaid;
            totalFeePending = firstYearTotalHostelFeePending + firstYearTotalTuitionFeePending + secondYearTotalHostelFeePending + secondYearTotalTuitionFeePending;
            console.log(totalFeePaid, 'end');
            if (!branchAggregates[branch]) {
              branchAggregates[branch] = {
                feePaid: 0,
                feePending: 0,
              };
            }
            
            // Accumulate totals for each branch
            branchAggregates[branch].feePaid += totalFeePaid;
            branchAggregates[branch].feePending += totalFeePending;
            totalFeePaid=0;
            totalFeePending=0;
  
            console.log(branchAggregates)
        });
      
        return branchAggregates;
      };
      
      
      const transformForBranchChart = (aggregatedData) => {
        const branches = Object.keys(aggregatedData);
      
        const datasets = [
          {
            label: 'Fee Paid',
            data: branches.map((branch) => aggregatedData[branch].feePaid),
            backgroundColor: 'rgba(54, 162, 235, 0.8)', // Example color for fee paid
          },
          // {
          //   label: 'Fee Pending',
          //   data: branches.map((branch) => aggregatedData[branch].feePending),
          //   backgroundColor: 'rgba(255, 99, 132, 0.8)', // Example color for fee pending
          // },
        ];
      
        return { labels: branches, datasets };
      };

    const aggregatedDataByBranch = aggregateFeesByBranch(analyticsReceipts);
    const { labels: branchLabels, datasets: branchDatasets } = transformForBranchChart(aggregatedDataByBranch);
    
    const branchChartData = {
      labels: branchLabels,
      datasets: branchDatasets,
    };
  

    const fetchBranches = useCallback(async () => {
      try {
        var SchoolManagementSystemApi = require('school_management_system_api');
        var api = new SchoolManagementSystemApi.DbApi();
        const opts = {
          body: {
            collectionName: 'branches',
            query: {},
            type: 'findMany',
          },
        };
  
        console.log(opts.body);
  
        api.dbGet(opts, function (error, data, response) {
          if (error) {
            console.error('API Error:', error);
          } else {
            try {
              const responseBody = response.body; // Assuming response.body is already in JSON format
              console.log(responseBody);
              setBranches(responseBody); // Assuming the actual data is in responseBody.data 
            } catch (parseError) {
              console.error('Error parsing response:', parseError);
            }
          }
        });
      } catch (error) {
        console.error('Error:', error);
      }
    }, []); 

    useEffect(() => {

      fetchBranches()
    },[]);

    const generateBatches = () => {
          const startYear = 2022;
          const endYear = 2098;
          const batches = [];
          
          for (let year = startYear; year <= endYear; year += 1) {
            batches.push(`${year}-${year + 2}`);
          }
          
          return batches;
        };
        
        const batchOptions = generateBatches();









      return (
        <div className="bg-slate-400 rounded-2xl p-8 m-4">
            <div className="card bg-slate-600 text-black px-8 py-2 mx-32 mb-16  text-center"> {/* Increased padding */}
                <h2 className="text-2xl font-bold text-white text-center">Fee Payment Summary by Branch</h2>
            </div>
            <div className="flex justify-center items-center">
              <div>
                <div className="grid grid-cols-2 gap-4 mb-4">
                  {/* From Date */}
                  <div className="bg-slate-300 px-8 py-2 rounded-2xl m-2">
                    <label className="block text-lg font-bold text-gray-700">From Date:</label>
                    <input
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      className="form-input mt-1 block w-full py-2 px-4 rounded-xl"
                    />
                  </div>

                  {/* To Date */}
                  <div className="bg-slate-300 px-8 py-2 rounded-2xl m-2">
                    <label className="block text-lg font-bold text-gray-700">To Date:</label>
                    <input
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      className="form-input mt-1 block w-full py-2 px-4 rounded-xl"
                      min={startDate}
                    />
                  </div>

                  {/* Branch */}
                  <div className="bg-slate-300 px-8 py-2 rounded-2xl m-2">
                    <label className="block text-lg font-bold text-gray-700">Branch:</label>
                    <select
                      multiple
                      required
                      name="branch"
                      id="branch"
                      value={selectedBranch}
                      onChange={handleBranchChange}
                      className="select select-bordered w-full"
                    >
                      <option value="">Select Branch</option>
                      {branches.map((branch, index) => (
                        <option key={index} value={branch.branchCode}>
                          {`${branch.branchName} (${branch.branchCode})`}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Batch */}
                  <div className="bg-slate-300 px-8 py-2 rounded-2xl m-2">
                    <label className="block text-lg font-bold text-gray-700">Batch:</label>
                    <select
                      multiple
                      value={selectedBatch}
                      onChange={(e) => {
                        const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
                        setSelectedBatch(selectedOptions);
                      }}
                      className="select select-bordered w-full"
                    >
                      <option value="" disabled>Select Batch</option>
                      {batchOptions.map((batch, index) => (
                        <option key={index} value={batch}>
                          {batch}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Mode Of Payment - Centered below the grid */}
                <div className="flex justify-center">
                  <div className="bg-slate-300 px-8 py-2 rounded-2xl m-2">
                    <label className="block text-lg font-bold text-gray-700">Mode Of Payment:</label>
                    <select
                      multiple
                      value={selectedModeOfPayment}
                      onChange={(e) => {
                        const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
                        setSelectedModeOfPayment(selectedOptions);
                      }}
                      className="select select-bordered"
                    >
                      <option value="" disabled>MODE OF PAYMENT</option>
                      <option value="BANK TRANSFER/UPI">BANK TRANSFER/UPI</option>
                      <option value="CASH">CASH</option>
                      <option value="CARD">CARD</option>
                      <option value="CHEQUE">CHEQUE</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>



          <div className="flex justify-center items-center">
            <button
              onClick={handleButtonClick} // Call fetchAnalyticsReceipts when the button is clicked
              className="btn my-8"
              style={{ backgroundColor: '#00A0E3', color: '#FFFFFF' }}
            >
              Fetch Analytics
            </button>
          </div>

          <div className='pt-16'>
            <div className="relative overflow-x-auto">
              <div style={{ minWidth: '1200px' }} className="rounded-3xl bg-slate-300"> 
                <Bar data={branchChartData} options={{
                  responsive: true,
                  plugins: {
                    legend: {
                      position: 'top',
                    },
                    title: {
                      display: true,
                      text: 'Fee Payment Summary by Branch',
                      font: {
                        size: 24, // Adjust as needed
                      },
                    },
                  },
                  scales: {
                    y: {
                      beginAtZero: true,
                      title: {
                        display: true,
                        text: 'Amount in Currency',
                        font: {
                          size: 16, // Adjust as needed
                        },
                      },
                    },
                    x: {
                      title: {
                        display: true,
                        text: 'Branch',
                        font: {
                          size: 16, // Adjust as needed
                        },
                      },
                    },
                  },
                }} />
              </div>
            </div>
          </div>

        </div>
      );
      
  };

  export default BranchAnalytics;
